import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import RewardList from './components/RewardList';
import CustomerList from './components/CustomerList';
import ReceiptLog from './components/ReceiptLog';
import VoucherLog from './components/VoucherLog';
import AddReward from './components/AddReward';
import LoyaltySettings from './components/LoyaltySettings';
import ExternalVoucherLog from './components/ExternalVoucherLog';
import TemplateEditor from './components/TemplateEditor';
import Login from './components/Login';  // Login component for OTP flow

const App = () => {
  // null = checking session, true = authed, false = not authed
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    fetch('/api/check_admin_session.php', {
      credentials: 'include',
    })
      .then(res => setAuthed(res.ok))
      .catch(() => setAuthed(false));
  }, []);

  if (authed === null) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      {authed && (
        <nav>
          <ul>
            <li><Link to="/rewards">Rewards</Link></li>
            <li><Link to="/customers">Customers</Link></li>
            <li><Link to="/receipts">Receipts</Link></li>
            <li><Link to="/vouchers">Vouchers</Link></li>
            <li><Link to="/external-vouchers">External Vouchers</Link></li>
            <li><Link to="/rewards/add">Add Reward</Link></li>
            <li><Link to="/loyalty-settings">Loyalty Settings</Link></li>
            <li><Link to="/notification-templates">Notification Templates</Link></li>
          </ul>
        </nav>
      )}

      <Routes>
        {/* Login route always available */}
        <Route
          path="/login"
          element={<Login onSuccess={() => setAuthed(true)} />}
        />

        {/* Protected routes - only when authed */}
        {authed && (
          <>
            <Route path="/" element={<Navigate to="/rewards" replace />} />
            <Route path="/rewards" element={<RewardList />} />
            <Route path="/customers" element={<CustomerList />} />
            <Route path="/receipts" element={<ReceiptLog />} />
            <Route path="/vouchers" element={<VoucherLog />} />
            <Route path="/external-vouchers" element={<ExternalVoucherLog />} />
            <Route path="/rewards/add" element={<AddReward />} />
            <Route path="/loyalty-settings" element={<LoyaltySettings />} />
            <Route path="/notification-templates" element={<TemplateEditor />} />
          </>
        )}

        {/* Catch-all redirects */}
        <Route
          path="*"
          element={<Navigate to={authed ? "/rewards" : "/login"} replace />}
        />
      </Routes>
    </Router>
  );
};

export default App;